import React, { useEffect, useState, useRef } from "react";
import { useParams } from 'react-router-dom';
import CustomHeader from "../../components/header/index.jsx";
import socketIOClient from "socket.io-client";
import './muleupgradeagent.scss';
import { Container, Col, Row } from 'react-bootstrap';
import "react-responsive-carousel/lib/styles/carousel.min.css";
import { useNavigate } from 'react-router-dom';
import url from "../../config.js"
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { Upload, FolderOpen, CheckCircle, Folder, Settings, Play, XCircle, Clock, FileText, AlertCircle, Download, RefreshCw, Github, Loader, MessageSquare, Bot, Search, Zap, Send } from 'lucide-react';

const domain = url.domain;
const backendUrl = url.backendUrl;
const socketEndpoint = url.SOCKET;

// ============= ENHANCED AGENT SERVICE WITH AI ANALYSIS =============
class AgentService {
    constructor(mode = 'scripted') {
        this.mode = mode;
    }

    async respond(event, data) {
        if (this.mode === 'scripted') {
            return this.getScriptedResponse(event, data);
        } else {
            return this.getAIResponse(event, data);
        }
    }

    // 🔥 SECURE: AI Analysis via Backend Proxy
    // async getAIInsights(analysisData, backendUrl) {
    //     try {
    //         // Call backend endpoint instead of Claude API directly
    //         const response = await fetch(backendUrl + '/api/v1/ai-analysis', {
    //             method: 'POST',
    //             headers: {
    //                 'Content-Type': 'application/json',
    //                 'x-access-token': localStorage.getItem('token')
    //             },
    //             body: JSON.stringify({
    //                 analysisData
    //             })
    //         });

    //         if (!response.ok) {
    //             throw new Error(`Analysis API error: ${response.status}`);
    //         }

    //         const result = await response.json();

    //         if (result.success && result.insights) {
    //             return result.insights;
    //         } else {
    //             throw new Error(result.error || 'AI analysis failed');
    //         }
    //     } catch (error) {
    //         console.error('AI Analysis Error:', error);
    //         // Fallback to scripted analysis
    //         return this.getScriptedAnalysis(analysisData);
    //     }
    // }

    getScriptedAnalysis(analysisData) {
        const { currentVersion, targetVersion, fileCount, flowCount, configCount, connectors, dependencies, warnings } = analysisData;

        const lines = [];

        lines.push('📊 **Project Analysis Complete**');
        lines.push('');
        lines.push('**Project Summary:**');
        lines.push(`- Current Version: ${currentVersion || 'Mule 4.x'}`);
        // lines.push(`- Target Version: ${targetVersion}`);
        lines.push(`- Total Files: ${fileCount}`);
        lines.push(`- Flows: ${flowCount || 'Unknown'}`);
        lines.push(`- Configurations: ${configCount || 'Unknown'}`);
        lines.push('');

        // 🔥 CHANGED: Show connectors with versions
        lines.push('**Detected Components:**');
        if (connectors && connectors.length > 0) {
            connectors.forEach(c => {
                // Check if connector is object with version or just string
                if (typeof c === 'object' && c.name && c.version) {
                    lines.push(`- ${c.name} (v${c.version})`);
                } else if (typeof c === 'string') {
                    lines.push(`- ${c}`);
                }
            });
        } else {
            lines.push('- Standard HTTP/Database connectors');
        }
        lines.push('');

        if (warnings && warnings.length > 0) {
            lines.push('⚠️ **Warnings & Issues:**');
            warnings.forEach(w => lines.push(`${w}`));
            lines.push('');
        }

        if (fileCount > 500) {
            lines.push('⚠️ **Large Project Warning:**');
            lines.push('This is a substantial project. Migration may take 10-15 minutes.');
            lines.push('');
        }

        lines.push('**Recommendations:**');
        lines.push('- Review all custom transformations after migration');
        lines.push('- Test API endpoints thoroughly');
        lines.push('- Update connector configurations if needed');

        if (dependencies && dependencies.some(d => d.includes('apikit'))) {
            lines.push('- APIKit may require manual updates');
        }
        lines.push('');

        const estimatedTime = fileCount > 500 ? '10-15 minutes' : fileCount > 200 ? '5-10 minutes' : '3-5 minutes';
        lines.push(`⏱️ **Estimated Migration Time:** ${estimatedTime}`);
        lines.push('');
        lines.push('✅ Ready to proceed with migration! ');

        return lines.join('\n');
    }


    getScriptedResponse(event, data) {
        const responses = {
            'welcome': "Hi! I'm your Mule Upgrade Agent. Ready to help you upgrade your Mule projects.",
            'source_selected': `${data?.sourceType === 'local' ? 'Local directory selected. Please upload your Mule project folder.' : data?.sourceType === 'git' ? 'Git repository mode selected. Provide your repository URL to continue.' : 'Multiple repositories mode selected. Upload your repo-list.txt file.'}`,
            'upload_prompt': "Please upload your Mule project folder to get started.",
            'upload_success': `Great! I've received ${data?.fileCount || 0} files..Please add configurations to analyse..`,
            'analyzing': "🔍 Analyzing your project structure, dependencies, and configurations...",
            'analysis_complete': "Analysis complete! Review the findings above.Please add the configuration and start migration.",
            'large_project_tip': "💡 Tip: For large projects, enabling 'Skip Tests' can speed up migration by 40%.",
            'config_runtime': `Upgrading to Mule ${data?.version}. ${this.getRuntimeNotes(data?.version)}`,
            'config_java': `Target Java version set to ${data?.version}. ${this.getJavaNotes(data?.version)}`,
            'config_toggle': `${data?.setting} ${data?.enabled ? 'enabled' : 'disabled'}. ${this.getSettingNotes(data?.setting, data?.enabled)}`,
            'git_url_set': "Git repository configured. Ready to clone and migrate when you are.",
            'migration_start': `Starting upgrade to Mule ${data?.targetVersion || '4.9.3'}. I'll keep you updated on progress...`,
            'scanning': "Scanning your project structure...",
            'scan_complete': `Found ${data?.flows || 0} flows and ${data?.configs || 0} configurations.`,
            'upgrading': `Upgrading ${data?.project || 'project'}...`,
            'project_success': `✓ Successfully upgraded ${data?.project || 'project'}`,
            'project_failed': `✗ Failed to upgrade ${data?.project || 'project'}`,
            'migration_complete': "All done! Your projects have been upgraded.",
            'download_ready': "Your upgraded projects are ready for download."
        };

        return responses[event] || data?.message || "Processing...";
    }

    getRuntimeNotes(version) {
        const notes = {
            '4.9.3': 'Latest stable version with improved DataWeave performance.',
            '4.8.0': 'Includes enhanced security features and bug fixes.',
            '4.7.0': 'Long-term support version, recommended for enterprise deployments.'
        };
        return notes[version] || 'Make sure your dependencies are compatible.';
    }

    getJavaNotes(version) {
        const notes = {
            '17': 'Latest LTS version, recommended for new projects.',
            '11': 'Stable LTS version, widely supported.',
            '8': '⚠️ Java 8 is reaching end of life. Consider upgrading to Java 11 or 17.'
        };
        return notes[version] || '';
    }

    getSettingNotes(setting, enabled) {
        const notes = {
            'skipTests': enabled
                ? 'Tests will be skipped. Migration will be faster but you should run tests manually after.'
                : 'Tests will run during migration. This ensures quality but takes longer.',
            'dynamicVersions': enabled
                ? 'Dependencies will use dynamic versions. Ensures latest compatible versions.'
                : 'Dependencies will use fixed versions from your project.',
            'cleanupClones': enabled
                ? 'Temporary git clones will be deleted after migration to save disk space.'
                : 'Git clones will be preserved for manual review.'
        };
        return notes[setting] || '';
    }

    async getAIResponse(event, data) {
        // Phase 2: Real AI integration for other events
        return this.getScriptedResponse(event, data);
    }
}

function MuleUpgrade({ onSourceSelected, selectedSource }) {
    // let { projId, projName } = useParams();
    // const filesRef = useRef([]);
    const fileInputRef = useRef(null);
    // const navigate = useNavigate();
    const [uploadedFiles, setUploadedFiles] = useState([]);
    const [isUploading, setIsUploading] = useState(false);
    const [sourceType, setSourceType] = useState('local');
    const [gitUrl, setGitUrl] = useState('');
    const [gitBranch, setGitBranch] = useState('main');
    const [repoListFile, setRepoListFile] = useState(null);
    const [migrationStatus, setMigrationStatus] = useState('idle');
    const [projects, setProjects] = useState([]);
    const [dependencyAnalysis, setDependencyAnalysis] = useState(null);
    const [analyzingDependencies, setAnalyzingDependencies] = useState(false);
    const [userConfirmed, setUserConfirmed] = useState(false);
    const [isAnalyzing, setIsAnalyzing] = useState(false);
    const [analysisComplete, setAnalysisComplete] = useState(false);
    const [analysisData, setAnalysisData] = useState(null);
    const [inputMessage, setInputMessage] = useState('');
    const [uploadPath, setUploadPath] = useState('');

    const [waitingForConfirmation, setWaitingForConfirmation] = useState(false);

    const [messages, setMessages] = useState([
        { type: 'agent', content: "Hi! I'm your Mule Upgrade Agent. Ready to help you upgrade your Mule projects.", timestamp: new Date().toLocaleTimeString() }
    ]);

    const [logsHeight, setLogsHeight] = useState(300);
    const [config, setConfig] = useState({
        targetRuntime: '4.9.3',
        targetJava: '17',
        targetBranch: 'main',
        destinationGitUrl: '',
        skipTests: true,
        dynamicVersions: true,
        cleanupClones: true
    });
    const [migrationProgress, setMigrationProgress] = useState({
        percentage: 0,
        step: '',
        eta: 0
    });
    const [showConfig, setShowConfig] = useState(false);
    const [summary, setSummary] = useState(null);
    const [sessionId, setSessionId] = useState(null);
    const [wsConnected, setWsConnected] = useState(false);
    const [serverPath, setServerPath] = useState('');
    const [uploadError, setUploadError] = useState('');
    const [canStartMigration, setCanStartMigration] = useState(false);

    const wsRef = useRef(null);
    const messagesEndRef = useRef(null);
    const reconnectTimeoutRef = useRef(null);
    const configRef = useRef(null);
    const socketRef = useRef(null);
    const agentService = useRef(new AgentService('scripted'));

    useEffect(() => {
        connectWebSocket();
        if (messagesEndRef.current) {
            messagesEndRef.current.scrollIntoView({ behavior: 'smooth' });
        }
        if (summary && summary.total > 0) {
            setLogsHeight(200);
        } else {
            setLogsHeight(300);
        }
        return () => {
            if (wsRef.current) {
                wsRef.current.close();
            }
            if (reconnectTimeoutRef.current) {
                clearTimeout(reconnectTimeoutRef.current);
            }
        };
    }, []);

    useEffect(() => {
        if (messagesEndRef.current) {
            messagesEndRef.current.scrollIntoView({ behavior: 'smooth' });
        }
    }, [messages]);
    const addMessage = async (content, type = 'agent', logType = 'info') => {
        setMessages(prev => [...prev, {
            type,
            content,
            timestamp: new Date().toLocaleTimeString(),
            logType
        }]);
    };

    const handleUserMessage = async (message) => {
        const normalizedMsg = message.toLowerCase().trim();

        // If waiting for confirmation
        if (waitingForConfirmation) {
            const confirmKeywords = ['confirm', 'yes', 'start', 'proceed', 'go', 'ok', 'start migration', 'let\'s go'];
            const cancelKeywords = ['cancel', 'no', 'wait', 'stop', 'abort', 'change'];

            if (confirmKeywords.some(keyword => normalizedMsg.includes(keyword))) {
                setWaitingForConfirmation(false);
                setUserConfirmed(true);
                setCanStartMigration(true);

                await addMessage(message, 'user');
                await addMessage(
                    '🚀 **Migration confirmed! Starting now...**\n\n' +
                    'Initiating migration process...',
                    'agent',
                    'success'
                );
                setMigrationStatus('running');


                // 🔥 Start migration immediately after brief delay
                setTimeout(() => {
                    startMigration();
                }, 1000);

                return;
            }

            if (cancelKeywords.some(keyword => normalizedMsg.includes(keyword))) {
                setWaitingForConfirmation(false);
                // 🔥 NEW: Reset dependency analysis to allow re-configuration
                setDependencyAnalysis(null);
                setUserConfirmed(false);
                setCanStartMigration(false);

                await addMessage(message, 'user');
                await addMessage(
                    '✋ **Migration paused**\n\n' +
                    'No problem! You can now:\n\n' +
                    '1. **Adjust Configuration**: Change runtime version, Java version, or other settings in the Configuration section above\n' +
                    '2. **Re-analyze**: Type "analyze dependencies" to run a fresh analysis with your new settings\n\n' +
                    'Take your time to review and adjust as needed.',
                    'agent',
                    'info'
                );

                // 🔥 NEW: Auto-scroll to configuration section
                setTimeout(() => {
                    if (configRef.current) {
                        configRef.current.scrollIntoView({
                            behavior: 'smooth',
                            block: 'center'
                        });
                    }
                }, 500);

                return;
            }

            // If unrecognized input during confirmation
            await addMessage(message, 'user');
            await addMessage(
                'I didn\'t quite understand that. To proceed:\n\n' +
                '✅ Type "**confirm**", "**yes**", or "**proceed**" to start migration\n' +
                '❌ Type "**no**", "**cancel**", or "**change**" to adjust configuration',
                'agent',
                'warning'
            );
            return;
        }

        // If migration confirmed and user says "start now"
        if (userConfirmed && (normalizedMsg.includes('start') || normalizedMsg === 'go')) {
            await addMessage(message, 'user');
            await startMigration();
            return;
        }

        // Regular chat functionality
        await addMessage(message, 'user');

        // 🔥 NEW: Handle analyze dependencies command
        if (normalizedMsg.includes('analyze') || normalizedMsg.includes('analyse')) {
            if (!analysisComplete) {
                await addMessage(
                    '⚠️ Please upload a project first before running dependency analysis.',
                    'agent',
                    'warning'
                );
                return;
            }
            setDependencyAnalysis(null);
            setUserConfirmed(false);
            setCanStartMigration(false);
            setWaitingForConfirmation(false);

            await addMessage(
                `🔄 **Starting fresh dependency analysis**\n\n` +
                `Current configuration:\n` +
                `- Target Runtime: Mule ${config.targetRuntime}\n` +
                `- Target Java: ${config.targetJava}\n` +
                `- Skip Tests: ${config.skipTests ? 'Yes' : 'No'}\n\n` +
                `Analyzing...`,
                'agent',
                'info'
            );

            await analyzeDependencies();
            return;
        }

        // 🔥 NEW: Handle configuration change hints
        if (normalizedMsg.includes('config') || normalizedMsg.includes('setting') || normalizedMsg.includes('change')) {
            await addMessage(
                '⚙️ **Configuration Options**\n\n' +
                'You can adjust these settings in the Configuration section above:\n\n' +
                '• **Target Runtime**: Choose your target Mule version\n' +
                '• **Target Java**: Select Java version (8, 11, or 17)\n' +
                '• **Skip Tests**: Enable/disable test execution\n' +
                '• **Dynamic Versions**: Use latest compatible versions\n' +
                '• **Cleanup Clones**: Remove temporary files\n\n' +
                'After making changes, type "**analyze dependencies**" to re-run the analysis.',
                'agent',
                'info'
            );
            return;
        }

        // 🔥 NEW: Show help
        if (normalizedMsg.includes('help') || normalizedMsg === '?') {
            await addMessage(
                '💡 **Available Commands**\n\n' +
                '📊 **Analysis & Configuration:**\n' +
                '• "analyze dependencies" - Run dependency analysis\n' +
                '• "config" or "settings" - View configuration options\n\n' +
                '🚀 **Migration:**\n' +
                '• "confirm" or "yes" - Confirm and proceed\n' +
                '• "no" or "cancel" - Cancel and adjust settings\n' +
                '• "start now" - Begin migration immediately\n\n' +
                '❓ **Help:**\n' +
                '• "help" - Show this message\n\n' +
                'Just type naturally - I understand variations of these commands!',
                'agent',
                'info'
            );
            return;
        }

        // Default: Generic response
        await addMessage(
            '🤔 I\'m not sure what you mean.\n\n' +
            'Here\'s what I can help with:\n' +
            '• Type "**analyze dependencies**" to run analysis\n' +
            '• Type "**config**" to see configuration options\n' +
            '• Type "**help**" for all available commands',
            'agent',
            'info'
        );
    };

    // 🔥 NEW: Analyze Project with AI
    const analyzeProject = async (projectPath, fileCount) => {
        setIsAnalyzing(true);
        setAnalysisComplete(false);

        const analyzingMsg = await agentService.current.respond('analyzing');
        await addMessage(analyzingMsg, 'agent', 'info');

        try {
            const response = await fetch(backendUrl + '/api/v1/analyze-project', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'x-access-token': localStorage.getItem('token')
                },
                body: JSON.stringify({
                    projectPath,
                    targetVersion: config.targetRuntime
                })
            });

            if (!response.ok) {
                throw new Error(`Analysis failed: ${response.status}`);
            }

            const result = await response.json();

            if (result.success) {
                const analysis = result.analysis;
                setAnalysisData(analysis);
                const basicAnalysis = agentService.current.getScriptedAnalysis({
                    ...analysis,
                    targetVersion: config.targetRuntime,
                    fileCount
                });
                await addMessage(basicAnalysis, 'agent', 'info');

                // const aiInsights = await agentService.current.getAIInsights({
                //     ...analysis,
                //     targetVersion: config.targetRuntime,
                //     fileCount
                // }, backendUrl);

                // await addMessage(aiInsights, 'agent', 'info');

                const completeMsg = await agentService.current.respond('analysis_complete');
                await addMessage(completeMsg, 'agent', 'success');

                setAnalysisComplete(true);
                setCanStartMigration(true);

                // 🔥 NEW: Auto-show configuration after analysis
                setShowConfig(true);

                // 🔥 NEW: Scroll to configuration
                setTimeout(() => {
                    if (configRef.current) {
                        configRef.current.scrollIntoView({
                            behavior: 'smooth',
                            block: 'nearest'
                        });
                    }
                }, 500);

            } else {
                throw new Error(result.error || 'Analysis failed');
            }

        } catch (error) {
            console.error('[Analysis] Error:', error);
            if(sourceType === 'local') {
            await addMessage(`Analysis failed: ${error.message}. You can still proceed with upgrade.`, 'agent', 'warning');
            }
            setAnalysisComplete(true);
            setCanStartMigration(true);
        } finally {
            setIsAnalyzing(false);
        }
    };
    const analyzeDependencies = async () => {
        console.log('[analyzeDependencies] Starting...');

        // Reset states
        setDependencyAnalysis(null);
        setUserConfirmed(false);
        setCanStartMigration(true);
        setWaitingForConfirmation(false);

        console.log('[State Before]', { analyzingDependencies, dependencyAnalysis, userConfirmed });

        // 🔥 Set to true - no finally block to reset it!
        setAnalyzingDependencies(true);
        console.log('[State Set] analyzingDependencies = true');

        // await addMessage('🔍 Starting dependency analysis...', 'agent', 'info');

        try {
            // 🔥 NEW: Just call the backend API, don't call getAIInsights
            const response = await fetch(domain + '/api/v1/ai-analysis', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'x-access-token': localStorage.getItem('token')
                },
                body: JSON.stringify({
                    sourceType,
                    localPath: sourceType === 'local' ? serverPath : null,
                    gitUrl: sourceType === 'git' ? gitUrl : null,
                    gitBranch: sourceType === 'git' ? gitBranch : null,
                    repoListPath: sourceType === 'multi-git' ? serverPath : null,

                    projectPath: serverPath,
                    muleVersion: config.targetRuntime,
                    javaVersion: config.targetJava,
                    useDynamicVersions: config.dynamicVersions

                })
            });

            const data = await response.json();
            console.log('[analyzeDependencies] Backend response:', data);
            if (!data.success) {
                throw new Error(data.error || 'Analysis failed');
            }



            console.log('✓ Analysis request sent - waiting for WebSocket updates...');

            // 🔥 DON'T set analyzingDependencies to false here
            // The WebSocket handler will do it when 'analysis-complete' event arrives

        } catch (error) {
            console.error('❌ Dependency analysis error:', error);
            await addMessage(`❌ Failed to start analysis: ${error.message}`, 'agent', 'error');

            // Only reset on error
            setAnalyzingDependencies(false);
        }

        // 🔥 NO finally block! Let WebSocket handle completion
    };
    const confirmMigration = async () => {
        setUserConfirmed(true);
        setCanStartMigration(true);
        await addMessage('✅ upgrade confirmed! You can now start the upgrade.', 'agent', 'success');
    };
    const handleFileUpload = async (event) => {
        console.log('[Upload] Selected files for upload');
        const files = Array.from(event.target.files);

        if (files.length === 0) {
            setUploadError('No files selected');
            await addMessage('No files selected. Please try again.', 'agent', 'error');
            return;
        }

        setIsUploading(true);
        setUploadError('');
        setUploadedFiles(files);
        setAnalysisComplete(false);
        setCanStartMigration(false);

        await addMessage(`Uploading ${files.length} files to server...`, 'agent', 'info');

        try {
            const formData = new FormData();
            const filePaths = [];

            files.forEach((file, index) => {
                const relativePath = file.webkitRelativePath || file.name;
                filePaths.push(relativePath);
                console.log(`[Upload] Appending file ${index}: ${relativePath}`);
                formData.append('files', file);
            });

            formData.append('filePaths', JSON.stringify(filePaths));
            console.log(`[Upload] Uploading ${files.length} files with paths`);

            const response = await fetch(backendUrl + '/api/v1/upload-project', {
                method: 'POST',
                body: formData,
            });

            if (!response.ok) {
                throw new Error(`Upload failed: ${response.statusText}`);
            }

            const result = await response.json();

            if (result.success) {
                console.log('[Upload] Success:', result);
                setServerPath(result.projectPath);

                const successMsg = await agentService.current.respond('upload_success', {
                    fileCount: result.fileCount
                });
                await addMessage(successMsg, 'agent', 'success');

                // 🔥 TRIGGER AUTOMATIC ANALYSIS
                if(sourceType === 'local' ){
                await analyzeProject(result.projectPath, result.fileCount);}
                else{
                    setAnalysisComplete(true);
                }

            } else {
                throw new Error(result.error || 'Upload failed');
            }

        } catch (error) {
            console.error('[Upload] Error:', error);
            setUploadError(error.message);
            setUploadedFiles([]);
            setServerPath('');
            setCanStartMigration(false);
            await addMessage(`Upload failed: ${error.message}`, 'agent', 'error');
        } finally {
            setIsUploading(false);
            if (fileInputRef.current) {
                fileInputRef.current.value = '';
            }
        }
    };

    const handleSourceClick = async (source) => {
        setSourceType(source);
        setUploadedFiles([]);
        setServerPath('');
        setUploadError('');
        setCanStartMigration(false);
        if (source !== 'local') {
            setAnalysisComplete(true);
            setCanStartMigration(true);
        }

        const sourceMsg = await agentService.current.respond('source_selected', { sourceType: source });
        await addMessage(sourceMsg, 'agent', 'info');
    };

    const handleUploadClick = () => {
        console.log('[Debug] Upload button clicked');
        if (fileInputRef.current && typeof fileInputRef.current.click === 'function') {
            fileInputRef.current.click();
        }
    };

    const handleConfigChange = async (field, value) => {
        const newConfig = { ...config, [field]: value };
        setConfig(newConfig);

        // Only show warning if analysis was already done
        if (dependencyAnalysis) {
            setDependencyAnalysis(null);
            // setUserConfirmed(true);
            // setCanStartMigration(true);

            // Show warning about outdated analysis
            await addMessage(
                `⚙️ Configuration updated: **${field}** \n\n` +
                `⚠️ Previous analysis is now outdated. Type "**analyze dependencies**" to run a fresh analysis with your new settings.`,
                'agent',
                'warning'
            );
        }
        // If no analysis done yet, just silently update config - no message needed
    };
    const handleGitUrlChange = async (value) => {
        setGitUrl(value);
        if (value.trim()) {
            const msg = await agentService.current.respond('git_url_set');
            await addMessage(msg, 'agent', 'success');
            setCanStartMigration(true);
        }
    };

    const connectWebSocket = () => {
        try {
            var socketUrl = url.SOCKET;
            console.log("URLLLLLLLL", socketUrl);
            const socket = socketIOClient(socketUrl, { rejectUnauthorized: true, transports: ['websocket'] });
            console.log("socket project details", socket);

            socket.on("connect", function () {
                console.log("Socket connected");
                setWsConnected(true);
                addMessage('Connected to upgrade server', 'agent', 'success');
            });

            socket.off("mule-migration").on("mule-migration", (data) => {
                console.log('📨 Received mule-upgrade event:', data.type);
                handleWebSocketMessage(data);
            });

            socket.on("error", function (error) {
                console.error('WebSocket error:', error);
                setWsConnected(false);
                addMessage('WebSocket connection error', 'agent', 'error');
            });

            socket.on("connect_error", (error) => {
                console.error('❌ Connection error:', error);
                setWsConnected(false);
            });

            socket.on("disconnect", function () {
                console.log('WebSocket disconnected');
                setWsConnected(false);
                addMessage('Disconnected from upgrade server', 'agent', 'warning');

                reconnectTimeoutRef.current = setTimeout(() => {
                    addMessage('Attempting to reconnect...', 'agent', 'info');
                    connectWebSocket();
                }, 3000);
            });
            socket.off("joined-session").on("joined-session", (data) => {
                console.log('✅ Joined session room:', data.sessionId);
                addMessage('Connected to upgrade session', 'agent', 'info');
            });

            wsRef.current = socket;
        } catch (error) {
            console.error('Failed to create WebSocket connection:', error);
            setWsConnected(false);
        }
    };

    const toggleConfig = () => {
        setShowConfig(!showConfig);
        if (!showConfig && configRef.current) {
            setTimeout(() => {
                configRef.current.scrollIntoView({
                    behavior: 'smooth',
                    block: 'nearest'
                });
            }, 100);
        }
    };

    const handleWebSocketMessage = async (message) => {
        switch (message.type) {
            case 'log':
                await addMessage(message.data.message, 'agent', message.data.type);
                break;
            case 'analysis-complete':
                const { projectsAnalyzed, updatesRequired, detailedOutput, reportInfo } = message.data;
                console.log('[State Before Complete]', { analyzingDependencies });

                setAnalyzingDependencies(false);
                console.log('[State Set] analyzingDependencies = false');

                setDependencyAnalysis(true);
                setWaitingForConfirmation(true);

                // Optional: Store report info if needed
                if (reportInfo) {
                    // You could store this in state to show a download link
                    console.log('Report available at:', reportInfo.reportUrl);
                }
                break;

            case 'project':
                updateProjectStatus(message.data);
                break;

            case 'summary':
                setSummary(message.data);
                break;

            case 'progress':
                setMigrationProgress(message.data);
                break;

            case 'complete':
                const finalStatus = message.data.success ? 'completed' : 'failed';
                setMigrationStatus(finalStatus);

                if (message.data.summary) {
                    setSummary(message.data.summary);
                }

                const completeMsg = await agentService.current.respond('upgrade_complete');
                await addMessage(completeMsg, 'agent', message.data.success ? 'success' : 'error');

                if (message.data.success) {
                    const downloadMsg = await agentService.current.respond('download_ready');
                    await addMessage(downloadMsg, 'agent', 'info');
                }

                setMigrationProgress({ percentage: 100, step: 'Complete', eta: 0 });
                break;

            case 'error':
                await addMessage(message.data.message, 'agent', 'error');
                if (message.data.fatal) {
                    setMigrationStatus('failed');
                }
                break;

            default:
                console.log('Unknown message type:', message.type);
        }
    };

    const updateProjectStatus = (projectData) => {
        setProjects(prev => {
            const existing = prev.find(p => p.name === projectData.name);
            if (existing) {
                return prev.map(p =>
                    p.name === projectData.name ? { ...p, ...projectData } : p
                );
            }
            return [...prev, projectData];
        });
    };

    const startMigration = async () => {
        if (!wsConnected) {
            await addMessage('Not connected to server. Please wait for connection...', 'agent', 'error');
            return;
        }

        if (!analysisComplete) {
            await addMessage('Please wait for project analysis to complete before starting upgrade.', 'agent', 'warning');
            return;
        }

        setMigrationStatus('running');
        setProjects([]);
        setSummary(null);

        const migrationData = {
            sourceType,
            localPath: sourceType === 'local' ? serverPath : null,
            gitUrl: sourceType === 'git' ? gitUrl : null,
            gitBranch: sourceType === 'git' ? gitBranch : null,
            repoListPath: sourceType === 'multi-git' ? serverPath : null,
            config,
            analysisData // Include analysis results
        };

        const startMsg = await agentService.current.respond('start upgrade', {
            targetVersion: config.targetRuntime
        });
        await addMessage(startMsg, 'agent', 'info');

        try {
            const response = await fetch(domain + '/api/v1/muleupgrade', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'x-access-token': localStorage.getItem('token')
                },
                body: JSON.stringify(migrationData)
            });

            if (!response.ok) {
                throw new Error(`HTTP error! status: ${response.status}`);
            }

            const result = await response.json();
            // 🔥 Log the ACTUAL response structure
            console.log('[Migration] Backend response:', result);
            console.log('[Migration] Response structure:', JSON.stringify(result, null, 2));


            if (result && result.success) {
                setSessionId(result.sessionId);
                await addMessage('Upgrade started successfully', 'agent', 'success');
                // await addMessage(`Session ID: ${result.sessionId}`, 'agent', 'info');
                await addMessage('Waiting for upgrade updates...', 'agent', 'info');

            } else {
                await addMessage(`Failed to start Upgrade: ${result.error || 'Unknown error'}`, 'agent', 'error');
                setMigrationStatus('idle');
            }

            // ⭐ JOIN THE SESSION ROOM
            if (result.sessionId && wsRef.current) {
                console.log('🔗 Joining session room:', result.sessionId);

                // Create a promise that resolves when joined
                const roomJoined = new Promise((resolve) => {
                    const timeout = setTimeout(() => {
                        console.warn('⚠️ Room join timeout, continuing anyway');
                        resolve();
                    }, 2000);

                    wsRef.current.once('joined-session', (data) => {
                        clearTimeout(timeout);
                        console.log('✅ Room join confirmed:', data.sessionId);
                        resolve();
                    });
                });

                wsRef.current.emit('join-session', result.sessionId);

                // Wait for confirmation
                await roomJoined;
                console.log('✅ Ready to receive messages');
            }

            await addMessage('🚀 Upgrade process has started. You will receive updates here shortly.', 'agent', 'info');

        } catch (error) {
            await addMessage(`Failed to connect to server: ${error.message}`, 'agent', 'error');
            setMigrationStatus('idle');
        }
    };

    const clearMessages = () => {
        setMessages([
            { type: 'agent', content: "Chat cleared. Ready to help!", timestamp: new Date().toLocaleTimeString() }
        ]);
    };

    const downloadProject = async (projectName) => {
        try {
            await addMessage(`Downloading ${projectName}...`, 'agent', 'info');

            const response = await fetch(`${domain}/api/download/${projectName}`, {
                headers: {
                    'x-access-token': localStorage.getItem('token')
                }
            });

            if (!response.ok) {
                throw new Error(`HTTP error! status: ${response.status}`);
            }

            const blob = await response.blob();
            const url = window.URL.createObjectURL(blob);
            const a = document.createElement('a');
            a.href = url;
            a.download = `${projectName}.zip`;
            document.body.appendChild(a);
            a.click();
            window.URL.revokeObjectURL(url);
            document.body.removeChild(a);

            await addMessage(`Downloaded ${projectName}.zip successfully!`, 'agent', 'success');
        } catch (error) {
            await addMessage(`Download failed: ${error.message}`, 'agent', 'error');
        }
    };

    const downloadAllProjects = async () => {
        const successfulProjects = projects.filter(p => p.status === 'success');

        if (successfulProjects.length === 0) {
            await addMessage('No successful projects to download', 'agent', 'warning');
            return;
        }

        await addMessage(`Downloading ${successfulProjects.length} projects...`, 'agent', 'info');

        for (const project of successfulProjects) {
            await downloadProject(project.name);
            await new Promise(resolve => setTimeout(resolve, 500));
        }

        await addMessage(`All ${successfulProjects.length} projects downloaded!`, 'agent', 'success');
    };
    console.log('[Render] MuleUpgrade component rendering', gitUrl);
    return (
        <div className="root">
            <CustomHeader />
            <main className="content">
                <div className="project-overview-wrap">
                    <Container className="project-overview-container">
                        <div className="mule-migration">
                            <div className="mule-container">
                                <h1 className="mule-page-title">
                                    <Bot className="mule-page-title__icon" />
                                    Mule Upgrade Agent
                                </h1>
                                <div className="mule-layout">
                                    {/* Left Panel - Configuration */}
                                    <aside className="mule-sidebar">
                                        {/* Source Selection */}
                                        <section className="mule-card">
                                            <h2 className="mule-card__title">
                                                <Upload className="mule-card__icon" />
                                                Upgrade Source
                                            </h2>

                                            <div className="mule-source-types">
                                                <div
                                                    className={`mule-source-type ${sourceType === 'local' ? 'mule-source-type--active' : ''}`}
                                                    onClick={() => handleSourceClick('local')}
                                                >
                                                    <FolderOpen size={24} />
                                                    <div className="source-content">
                                                        <h4>Local Directory</h4>
                                                        <p>Migrate from local folder</p>
                                                    </div>
                                                </div>

                                                <button
                                                    onClick={() => handleSourceClick('git')}
                                                    className={`mule-source-type ${sourceType === 'git' ? 'mule-source-type--active' : ''}`}
                                                >
                                                    <Github className="mule-source-type__icon" />
                                                    <div className="mule-source-type__content">
                                                        <div className="mule-source-type__name">Git Repository</div>
                                                        <div className="mule-source-type__description">Single repo upgrade</div>
                                                    </div>
                                                </button>

                                                <button
                                                    onClick={() => handleSourceClick('multi-git')}
                                                    className={`mule-source-type ${sourceType === 'multi-git' ? 'mule-source-type--active' : ''}`}
                                                >
                                                    <FileText className="mule-source-type__icon" />
                                                    <div className="mule-source-type__content">
                                                        <div className="mule-source-type__name">Multiple Repos</div>
                                                        <div className="mule-source-type__description">Batch upgrade via list</div>
                                                    </div>
                                                </button>
                                            </div>

                                            {/* Input Fields */}
                                            <div className="muleinput-section">
                                                {sourceType === 'local' && (
                                                    <>
                                                        <input
                                                            ref={fileInputRef}
                                                            type="file"
                                                            webkitdirectory="true"
                                                            directory="true"
                                                            multiple
                                                            onChange={handleFileUpload}
                                                            style={{ display: 'none' }}
                                                        />

                                                        {uploadedFiles.length === 0 && !isUploading && !isAnalyzing ? (
                                                            <button
                                                                className="upload-btn"
                                                                onClick={handleUploadClick}
                                                            >
                                                                <Upload size={20} />
                                                                Select Folder to Upload
                                                            </button>
                                                        ) : null}

                                                        {isUploading && (
                                                            <div className="upload-status">
                                                                <Loader className="spinner" size={20} />
                                                                <span>Uploading {uploadedFiles.length} files to server...</span>
                                                            </div>
                                                        )}

                                                        {/* 🔥 NEW: Analysis Status */}
                                                        {isAnalyzing && (
                                                            <div className="analysis-status">
                                                                <Search className="spinner" size={20} />
                                                                <span>Analyzing project with AI...</span>
                                                            </div>
                                                        )}

                                                        {uploadError && (
                                                            <div className="upload-error">
                                                                <span>❌ {uploadError}</span>
                                                                <button onClick={handleUploadClick}>Try Again</button>
                                                            </div>
                                                        )}

                                                        {uploadedFiles.length > 0 && !isUploading && serverPath && analysisComplete && (
                                                            <div className="upload-success">
                                                                <div className="success-header">
                                                                    <CheckCircle size={24} color="#10b981" />
                                                                    <div className="success-info">
                                                                        <h4>Analysis Complete!</h4>
                                                                        <p>{uploadedFiles.length} files analyzed</p>
                                                                    </div>
                                                                </div>

                                                                <div className="server-path-section">
                                                                    {/* <div className="server-path-info">
                                                                        <strong>Server Path:</strong>
                                                                        <code>{serverPath}</code>
                                                                    </div> */}

                                                                    <button
                                                                        className="change-folder-btn"
                                                                        onClick={handleUploadClick}
                                                                    >
                                                                        Change Folder
                                                                    </button>
                                                                </div>
                                                            </div>
                                                        )}
                                                    </>
                                                )}

                                                {sourceType === 'git' && (
                                                    <>
                                                        <div className="mule-form-group">
                                                            <label className="mule-form-label">Git Repository URL</label>
                                                            <input
                                                                type="text"
                                                                value={gitUrl}
                                                                onChange={(e) => handleGitUrlChange(e.target.value)}
                                                                placeholder="https://github.com/user/repo.git"
                                                                className="mule-form-input"
                                                            />
                                                        </div>
                                                        <div className="mule-form-group">
                                                            <label className="mule-form-label">Branch</label>
                                                            <input
                                                                type="text"
                                                                value={gitBranch}
                                                                onChange={(e) => setGitBranch(e.target.value)}
                                                                placeholder="main"
                                                                className="mule-form-input"
                                                            />
                                                        </div>
                                                    </>
                                                )}

                                                {sourceType === 'multi-git' && (
                                                    <div className="mule-form-group">
                                                        <label className="form-label">Repository List File (repo-list.txt)</label>
                                                        <input
                                                            type="file"
                                                            accept=".txt"
                                                            onChange={handleFileUpload}
                                                            className="mule-form-file-input"
                                                            id="repo-file"
                                                        />
                                                        <label htmlFor="repo-file" className="mule-form-file-label">
                                                            <Upload className="mule-form-file-icon" />
                                                            {repoListFile ? repoListFile.name : 'Upload repo-list.txt'}
                                                        </label>
                                                    </div>
                                                )}
                                            </div>
                                        </section>

                                        {/* Configuration */}
                                        {/* <section className="mule-card" ref={configRef}>
                                            <button
                                                onClick={toggleConfig}
                                                className="mule-card__toggle"
                                                 disabled={!analysisComplete}
                                            > */}
                                        {analysisComplete && (
                                            <section className="mule-card" ref={configRef}>
                                                <button
                                                    onClick={toggleConfig}
                                                    className="mule-card__toggle"
                                                >
                                                    <div className="mule-card__toggle-left">
                                                        <Settings className="mule-card__icon" />
                                                        <h2 className="mule-card__title">Configuration</h2>
                                                    </div>
                                                    <span className="mule-card__toggle-icon">{showConfig ? '−' : '+'}</span>
                                                </button>

                                                {showConfig && (
                                                    <div className="mule-config-content">
                                                        {dependencyAnalysis && (
                                                            <div className="config-notice">
                                                                <AlertCircle size={16} />
                                                                <span>Changing settings will require re-analysis</span>
                                                            </div>
                                                        )}
                                                        <div className="mule-form-group">
                                                            <label className="mule-form-label">Target Runtime</label>
                                                            <input
                                                                type="text"
                                                                value={config.targetRuntime}
                                                                onChange={(e) => handleConfigChange('targetRuntime', e.target.value)}
                                                                className="mule-form-input"
                                                            />
                                                        </div>

                                                        <div className="mule-form-group">
                                                            <label className="mule-form-label">Target Java</label>
                                                            <input
                                                                type="text"
                                                                value={config.targetJava}
                                                                onChange={(e) => handleConfigChange('targetJava', e.target.value)}
                                                                className="mule-form-input"
                                                            />
                                                        </div>
                                                        {sourceType!=='multi-git' && (
                                                            <>
                                                        <div className="mule-form-group">
                                                            <label className="mule-form-label">Destination Github URL</label>
                                                            <input
                                                                type="text"
                                                                value={config.destinationGitUrl}
                                                                onChange={(e) => handleConfigChange('destinationGitUrl', e.target.value)}
                                                                placeholder="https://github.com/user/repo.git"
                                                                className="mule-form-input"
                                                            />
                                                        </div>
                                                       

                                                        <div className="mule-form-group">
                                                            <label className="mule-form-label">Branch</label>
                                                            <input
                                                                type="text"
                                                                value={config.targetBranch}
                                                                onChange={(e) => handleConfigChange('targetBranch', e.target.value)}
                                                                className="mule-form-input"
                                                            />
                                                        </div>
                                                        </>
                                                        )}

                                                        <div className="mule-form-checkboxes">
                                                            <label className="mule-form-checkbox">
                                                                <input
                                                                    type="checkbox"
                                                                    checked={config.skipTests}
                                                                    onChange={(e) => handleConfigChange('skipTests', e.target.checked)}
                                                                />
                                                                <span>Skip Tests</span>
                                                            </label>

                                                            <label className="mule-form-checkbox">
                                                                <input
                                                                    type="checkbox"
                                                                    checked={config.dynamicVersions}
                                                                    onChange={(e) => handleConfigChange('dynamicVersions', e.target.checked)}
                                                                />
                                                                <span>Dynamic Version Resolution</span>
                                                            </label>

                                                            <label className="mule-form-checkbox">
                                                                <input
                                                                    type="checkbox"
                                                                    checked={config.cleanupClones}
                                                                    onChange={(e) => handleConfigChange('cleanupClones', e.target.checked)}
                                                                />
                                                                <span>Cleanup Clones</span>
                                                            </label>

                                                        </div>

                                                        {/* Analyze Dependencies Button */}
                                                        {/* Simpler approach - button stays, just disabled */}
                                                        {!dependencyAnalysis && (
                                                            <button
                                                                onClick={analyzeDependencies}
                                                                disabled={analyzingDependencies}
                                                                className={`mule-btn-analyze ${analyzingDependencies ? 'analyzing' : ''}`}
                                                            >
                                                                {analyzingDependencies ? (
                                                                    <>
                                                                        <Loader className="spinner" size={20} />
                                                                        Analyzing Dependencies...
                                                                    </>
                                                                ) : (
                                                                    <>
                                                                        <Search size={20} />
                                                                        Analyze Dependencies
                                                                    </>
                                                                )}
                                                            </button>
                                                        )}
                                                        {/* {!dependencyAnalysis && analysisComplete && (
                                                            <button
                                                                onClick={analyzeDependencies}
                                                                disabled={analyzingDependencies}
                                                                className="mule-btn-analyze"
                                                            >
                                                                {analyzingDependencies ? (
                                                                    <>
                                                                        <Loader className="spinner" size={20} />
                                                                        Analyzing Dependencies...
                                                                    </>
                                                                ) : (
                                                                    <>
                                                                        <Search size={20} />
                                                                        Analyze Dependencies
                                                                    </>
                                                                )}
                                                            </button>
                                                        )} */}



                                                    </div>
                                                )}
                                            </section>
                                        )}

                                        {/* Start Migration Button */}
                                        <button
                                            onClick={startMigration}
                                            disabled={migrationStatus === 'running' || !wsConnected || isAnalyzing}
                                            className={`mule-btn-start ${canStartMigration && migrationStatus !== 'running' && wsConnected && !isAnalyzing
                                                ? 'mule-btn-start--enabled'
                                                : 'mule-btn-start--disabled'
                                                }`}
                                        >
                                            {isAnalyzing ? (
                                                <>
                                                    <Search className="mule-btn-start__icon spinning" />
                                                    Analyzing Project...
                                                </>
                                            ) : (
                                                <>
                                                    <Play className="mule-btn-start__icon" />
                                                    {migrationStatus === 'running' ? 'Upgrade in Progress...' : 'Start Upgrade'}
                                                </>
                                            )}
                                        </button>
                                        {!analysisComplete && (
                                            <p className="mule-helper-text">
                                                {/* Upload a project to begin analysis */}
                                            </p>
                                        )}
                                        {/* {analysisComplete && !showConfig && (
                                            <p className="mule-helper-text mule-helper-text--success">
                                                ✓ Analysis complete. Review configuration above.Please add the configuration and start migration.
                                            </p>
                                        )} */}
                                    </aside>

                                    {/* Right Panel - Agent Chat */}
                                    <main className="mule-main-content">
                                        <aside className="mule-sidebar">
                                            {/* Summary Cards */}
                                            {summary && (
                                                <div className="mule-summary-grid">
                                                    <div className="mule-summary-card">
                                                        <div className="mule-summary-card__label">Total Projects</div>
                                                        <div className="mule-summary-card__value">{summary.total}</div>
                                                    </div>
                                                    <div className="mule-summary-card summary-card--success">
                                                        <div className="mule-summary-card__label">Success</div>
                                                        <div className="mule-summary-card__value">{summary.success}</div>
                                                    </div>
                                                    <div className="mule-summary-card summary-card--failed">
                                                        <div className="mule-summary-card__label">Failed</div>
                                                        <div className="mule-summary-card__value">{summary.failed}</div>
                                                    </div>
                                                    <div className="mule-summary-card">
                                                        <div className="mule-summary-card__label">Duration</div>
                                                        <div className="mule-summary-card__value">{summary.duration}s</div>
                                                    </div>
                                                </div>
                                            )}

                                            {/* Projects List */}
                                            {projects.length > 0 && (
                                                <section className="mule-card">
                                                    <h2 className="mule-card__title">Migrated Projects</h2>
                                                    <div className="mule-projects-list">
                                                        {projects.map((project, idx) => (
                                                            <div key={idx} className="mule-project-item">
                                                                <div className="mule-project-item__main">
                                                                    {project.status === 'pending' && (
                                                                        <Clock className="mule-project-item__icon mule-project-item__icon--pending" />
                                                                    )}
                                                                    {project.status === 'success' && (
                                                                        <CheckCircle className="mule-project-item__icon mule-project-item__icon--success" />
                                                                    )}
                                                                    {project.status === 'failed' && (
                                                                        <XCircle className="mule-project-item__icon mule-project-item__icon--failed" />
                                                                    )}
                                                                    <div className="mule-project-item__content">
                                                                        <div className="mule-project-item__name">{project.name}</div>
                                                                        {project.archived && (
                                                                            <div className="mule-project-item__path">
                                                                                Archived in: upgraded-projects/archive/{project.name}
                                                                            </div>
                                                                        )}
                                                                    </div>
                                                                </div>
                                                                <div className="mule-project-item__actions">
                                                                    {project.duration && (
                                                                        <span className="mule-project-item__duration">{project.duration}s</span>
                                                                    )}
                                                                    {project.status === 'success' && migrationStatus === 'completed' && (
                                                                        <button
                                                                            onClick={() => downloadProject(project.name)}
                                                                            className="mule-project-item__download"
                                                                            title="Download project"
                                                                        >
                                                                            <Download className="mule-project-item__download-icon" />
                                                                        </button>
                                                                    )}
                                                                </div>
                                                            </div>
                                                        ))}
                                                    </div>
                                                </section>
                                            )}

                                            {/* Agent Chat Section */}
                                            <section className="mule-card mule-chat-card">
                                                <div className="mule-card__header">
                                                    <h2 className="mule-card__title">
                                                        <MessageSquare className="mule-card__icon" />
                                                        Agent Chat
                                                    </h2>
                                                    <button onClick={clearMessages} className="mule-btn-clear-logs" title="Clear chat">
                                                        <RefreshCw className="mule-btn-clear-logs__icon" />
                                                    </button>
                                                </div>

                                                {/* Migration Status Banner */}
                                                {migrationStatus !== 'idle' && migrationStatus !== 'completed' && (
                                                    <div className={`migration-status migration-status--${migrationStatus}`}>
                                                        <div className="migration-status__content">
                                                            {migrationStatus === 'running' && (
                                                                <>
                                                                    <Clock className="migration-status__icon spinning" />
                                                                    <span>Upgrade in progress...</span>
                                                                </>
                                                            )}
                                                            {migrationStatus === 'failed' && (
                                                                <>
                                                                    <XCircle className="migration-status__icon" />
                                                                    <span>Upgrade failed. Check messages for details.</span>
                                                                </>
                                                            )}
                                                        </div>
                                                    </div>
                                                )}

                                                {/* Chat Messages */}
                                                <div className="agent-chat-container" style={{ height: `${logsHeight}px` }}>
                                                    {messages.length === 0 ? (
                                                        <div className="agent-chat-empty">
                                                            <Bot size={48} className="agent-chat-empty__icon" />
                                                            <p>Agent messages will appear here...</p>
                                                        </div>
                                                    ) : (
                                                        <>
                                                            {/* {messages.map((msg, idx) => (
                                                                <div
                                                                    key={idx}
                                                                    className={`agent-message agent-message--${msg.logType || 'info'}`}
                                                                >
                                                                    <div className={`mule-agent-avatar ${analyzingDependencies || migrationStatus === 'running' ? 'spinning' : ''
                                                                        }`}>
                                                                        <Bot size={20} />
                                                                    </div>
                                                                    <div className="agent-message__content">
                                                                        <div className="agent-message__header">
                                                                            <span className="agent-message__sender">Agent</span>
                                                                            <span className="agent-message__timestamp">{msg.timestamp}</span>
                                                                        </div>
                                                                        <div className="agent-message__text">
                                                                            {msg.content}
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            ))} */}
                                                            {messages.map((msg, idx) => {
                                                                // Check if this is the last message AND processing is active
                                                                const isLastMessage = idx === messages.length - 1;
                                                                const isProcessing = analyzingDependencies || migrationStatus === 'running';
                                                                const shouldSpin = isLastMessage && isProcessing;

                                                                return (
                                                                    <div
                                                                        key={idx}
                                                                        className={`agent-message agent-message--${msg.logType || 'info'}`}
                                                                    >
                                                                        <div className={`mule-agent-avatar ${shouldSpin ? 'spinning' : ''}`}>
                                                                            <Bot size={20} />
                                                                        </div>
                                                                        <div className="agent-message__content">
                                                                            <div className="agent-message__header">
                                                                                <span className="agent-message__sender">Agent</span>
                                                                                <span className="agent-message__timestamp">{msg.timestamp}</span>
                                                                            </div>
                                                                            <div className="agent-message__text">
                                                                                {msg.content}
                                                                            </div>
                                                                        </div>
                                                                    </div>
                                                                );
                                                            })}

                                                            <div ref={messagesEndRef} />
                                                        </>
                                                    )}
                                                </div>
                                                {/* Chat Input - Fixed at Bottom */}
                                                {wsConnected && (
                                                    <div className="mule-chat-input-section">
                                                        <div className="mule-chat-input-wrapper">
                                                            <input
                                                                type="text"
                                                                value={inputMessage}
                                                                onChange={(e) => setInputMessage(e.target.value)}
                                                                onKeyPress={(e) => {
                                                                    if (e.key === 'Enter' && inputMessage.trim()) {
                                                                        handleUserMessage(inputMessage);
                                                                        setInputMessage('');
                                                                    }
                                                                }}
                                                                placeholder={
                                                                    waitingForConfirmation
                                                                        ? "Type 'confirm' to proceed or 'cancel' to abort..."
                                                                        : migrationStatus === 'running'
                                                                            ? "Upgrade in progress..."
                                                                            : "Type a message or command..."
                                                                }
                                                                className="mule-chat-input"
                                                                disabled={migrationStatus === 'running'}
                                                            />
                                                            <button
                                                                onClick={() => {
                                                                    if (inputMessage.trim()) {
                                                                        handleUserMessage(inputMessage);
                                                                        setInputMessage('');
                                                                    }
                                                                }}
                                                                disabled={!inputMessage.trim() || migrationStatus === 'running'}
                                                                className="mule-chat-send-btn"
                                                                title="Send message"
                                                            >
                                                                <Send size={20} />
                                                            </button>
                                                        </div>
                                                    </div>
                                                )}
                                            </section>
                                        </aside>
                                    </main>
                                </div>
                            </div>
                        </div>
                    </Container>
                </div>
            </main>
        </div>
    );
}

export default MuleUpgrade;